import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import { appModule } from "./app";
import DataAsesmenGigi from "@/services/DataAsesmenGigi";
import store from "@/store";

@Module({ store, dynamic: true, name: "storeAsesmenGigi" })
class StoreAsesmenGigi extends VuexModule {
  asesmenGigi = {};

  @Mutation SET_ASESMEN_GIGI(asesmenGigi = {}) {
    this.asesmenGigi = asesmenGigi;
  }

  @Action actAsesmenGigiByReg(reg) {
    const dt = DataAsesmenGigi.getDataAsesmenGigiByReg(reg);
    appModule.setLoading(true);

    dt.then(dt => {
      const data = dt.data;
      appModule.setLoading(false);

      if (data.length > 0) {
        this.SET_ASESMEN_GIGI(data[0]);
      } else {
        this.SET_ASESMEN_GIGI(this.odontogramKosong);
      }
    });
  }

  @Action clear() {
    this.SET_ASESMEN_GIGI(this.odontogramKosong);
  }

  odontogramKosong = {
    is_signed: false,
    signed_at: null,
    oklusi: "",
    torus_palatinus: "",
    torus_mandibularis: "",
    palatum: "",
    diastema: "",
    gigi_anomali: "",
    lain_lain: "",
    d: "",
    m: "",
    f: "",
    jml_photo: "",
    jenis_photo: "",
    jml_rontgen: "",
    jenis_rontgen: "",
    gambar: "",

    data_medis: {
      golongan_darah: "",
      sistole: null,
      diastole: null,
      penyakit_jantung: "",
      diabetes: "",
      haemophilia: "",
      hepatitis: "",
      gastritis: "",
      penyakit_lainnya: "",
      alergi_obat: "",
      alergi_makanan: ""
    }
  };
}

export const storeAsesmenGigi = getModule(StoreAsesmenGigi);
